import type { ParseISOStringsOptions } from "@tellescope/type-correction";

/**
 * Predicate for parseISOStrings that prevents form response answer values from being
 * incorrectly parsed as dates, unless the answer type is 'date' (the only type whose
 * SDK value type is Date rather than string).
 *
 * When parseISOStrings recurses into a form response's `answer` object, this predicate
 * checks if the current key is `value` and the parent has a `type` field (indicating
 * it's a FormResponseValueAnswer). If so, it only allows parsing when `type === "date"`.
 */
export const formResponsePredicate = (<T extends Record<string, unknown>>(
  _value: unknown,
  key?: string,
  parent?: T
) => {
  if (key === "value" && parent && "type" in parent && parent.type !== "date") {
    return false;
  }
  return true;
}) satisfies NonNullable<ParseISOStringsOptions["predicate"]>;
